import { handleService } from './common'

export default {
  GetCoDTable (data) {
    let url = '/api/Device/GetCollectEquListByPgae'
    // debugger
    return handleService(url, data)
  },

  // 故障状态查询
  GetStatus (data) {
    console.log(data)
  }
}
